import React from "react";
import { UserWithFullName } from "components/Signals/Dashboard/DashboardMenu/ShareDialog/constants";

export const getMentionRegex = (fullName: string) => {
    const escapedName = fullName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return new RegExp(
        `(^|[\\s([{"'])@${escapedName}(?=$|[\\s.,!?;:)"'\\]}])`,
        "gi",
    );
};

type ApplyMentionSelectionArgs = {
    value: string;
    mentionStartIndex: number | null;
    setValue: (nextValue: string) => void;
    setCursorPosition: (nextValue: number) => void;
    pendingCursorPositionRef: React.MutableRefObject<number | null>;
    setMentionQuery: (nextValue: string) => void;
    setMentionStartIndex: (nextValue: number | null) => void;
    setMentionSelections: React.Dispatch<React.SetStateAction<UserWithFullName[]>>;
};

export const applyMentionSelection = (
    user: UserWithFullName,
    {
        value,
        mentionStartIndex,
        setValue,
        setCursorPosition,
        pendingCursorPositionRef,
        setMentionQuery,
        setMentionStartIndex,
        setMentionSelections,
    }: ApplyMentionSelectionArgs,
) => {
    if (mentionStartIndex === null) return;
    // Replace the "@" token at the caret, then move the caret to the end of the inserted mention.
    const mentionEndIndex = (() => {
        let idx = mentionStartIndex + 1;
        while (idx < value.length && !/\s/.test(value[idx])) {
            idx += 1;
        }
        return idx;
    })();

    const before = value.slice(0, mentionStartIndex);
    const after = value.slice(mentionEndIndex);
    const nextValue = `${before}@${user.fullName} ${after}`.replace(/\s+$/, " ");
    const nextCursorPosition = `${before}@${user.fullName} `.length;
    setValue(nextValue);
    setCursorPosition(nextCursorPosition);
    pendingCursorPositionRef.current = nextCursorPosition;
    setMentionQuery("");
    setMentionStartIndex(null);
    setMentionSelections((prev) => {
        if (prev.some((selection) => selection.userId === user.userId)) {
            return prev;
        }
        return [...prev, user];
    });
};
